import React from "react";
import { CircularProgress, IconButton } from "@mui/material";
import { colorEasyRed, colorGreen } from "../App/theme";
import CancelIcon from '@mui/icons-material/Close';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import CheckIcon from '@mui/icons-material/Check';

export function ConfirmIconButton({ title, onClick, color, fontSize, loading, disabled }) {
    fontSize = fontSize || 16;

    const buttonProps = {
        onClick: onClick,
        disabled
    };

    const renderButtonContent = () => {
        if (loading) {
            return <CircularProgress size={fontSize} sx={{ color: color, marginRight: '2px' }} />;
        } else {
            switch (title) {
                case 'Cancel':
                    return <CancelIcon style={{ fontSize }}/>;
                case 'Delete':
                    return <DeleteForeverIcon style={{ color: colorEasyRed, fontSize }} />;
                case 'Save':
                    return <CheckIcon style={{ color: !disabled ? colorGreen : 'gray', fontSize }} />;
                default:
                    return title;
            }
        }
    };

    if (loading) return renderButtonContent();

    return (
        <IconButton {...buttonProps} data-testid={title === 'Delete' ? "confirm-delete-chat-id" : undefined}>
            {renderButtonContent()}
        </IconButton>
    );
}